module.exports = __webpack_public_path__ + "guoouBanner.jpg?8da2eafbda74b6c3986f7549de00f6f8";